// src/App.js
import React, { useContext } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { AuthContextProvider, AuthContext } from "./AuthContext/Authcontext";
import { LanguageProvider } from "./context/LanguageContext"; // Import LanguageProvider
import MainRoute from "./MasterEntry/MainRoute/MainRoute";

function AppContent() {
  const { user } = useContext(AuthContext);

  return (
    <>
      <MainRoute />
    </>
  );
}

function App() {
  return (
    <AuthContextProvider>
      <LanguageProvider> {/* LanguageProvider added here */}
        <AppContent />
      </LanguageProvider>
    </AuthContextProvider>
  );
}

export default App;